<template>
  <v-dialog
    :model-value="isOpen"
    :scrim="scrim"
    persistent
    width="300"
    :retain-focus="false"
    no-click-animation
    @click:outside="$emit('click:outside', $event)"
  >
    <v-card color="primary" dark>
      <v-card-text class="pt-5 pb-5">
        <v-progress-linear indeterminate color="white" class="ma-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ isOpen?: boolean; scrim?: boolean }>(), {
  isOpen: true,
  scrim: undefined,
});
defineEmits<{ (e: 'click:outside', v: Event): void }>();
</script>
